import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Spin } from "antd";
import { useApolloClient } from "@apollo/client";
import CustomBackButton from "../../commonComponents/CustomBackButton";
import LocationSelect from "../../commonComponents/LocationSelect";
import {
  getAdminSelectedLocation,
  setLocation,
  setLocationId,
} from "../../../redux/slices/adminSelectedLocation";
import { GET_LOCATION_DETAILS } from "../../../graphql/query";
import { getCompanyId } from "../../../redux/slices/companySlice";
import CustomTypography from "../../commonComponents/CustomTypography";

const LocationBackButton = ({ onBack }) => {
  const dispatch = useDispatch();
  const client = useApolloClient();
  const selectedLocation = useSelector(getAdminSelectedLocation);
  const companyId = useSelector(getCompanyId);
  const [lazyLoading, setLazyLoading] = useState(false);

  const handleLocationChange = async val => {
    try {
      document.activeElement?.blur();
      setLazyLoading(true);
      // Use client.query directly with `network-only` so every header switch
      // hits the API. `useLazyQuery` was returning stale cached data on repeat
      // invocations, which left the form preselect on the previous location.
      const { data } = await client.query({
        query: GET_LOCATION_DETAILS,
        variables: { locationId: +val },
        fetchPolicy: "network-only",
      });
      if (data?.getSpecificLocation) {
        dispatch(setLocation(data.getSpecificLocation));
        dispatch(setLocationId(+val));
      }
    } catch (error) {
      console.error("Error in handleRefetchLocationDetails", error);
    } finally {
      setLazyLoading(false);
    }
  };

  return (
    <CustomBackButton
      onBack={() => onBack({})}
      buttonText={selectedLocation?.title}
      leftExtra={
        lazyLoading ? (
          <div className="flex items-center gap-3">
            <Spin size="small" />
            <p className="text-twLinkColor">Location is being switched...</p>
          </div>
        ) : null
      }
      extraa={
        <div className="w-96 flex gap-2 items-center justify-end">
          <CustomTypography.Body>Switch location</CustomTypography.Body>
          <LocationSelect
            onChange={async val => {
              handleLocationChange(val);
            }}
            selectWidth="w-[12rem]"
            isLoading={lazyLoading}
            value={selectedLocation?.id}
            skip={!companyId}
            variables={{ companyId, isAllLocations: true }}
            placeholder="Select location"
            addLocationTypeLabel={false}
            allowClear={false}
            fetchPolicy="cache-and-network"
          />
        </div>
      }
    />
  );
};

export default LocationBackButton;
